import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import dayjs from "dayjs";

import { FromField } from "../FromField";
import { ToField } from "../ToField";
import {
	FLIGHTS_DATES_FIELD_ID,
	FLIGHTS_FROM_MULTIPLE_FIELD_ID_1,
	FLIGHTS_FROM_MULTIPLE_FIELD_ID_2,
	FLIGHTS_FROM_MULTIPLE_FIELD_ID_3,
	FLIGHTS_TO_MULTIPLE_FIELD_ID_1,
	FLIGHTS_TO_MULTIPLE_FIELD_ID_2,
	FLIGHTS_TO_MULTIPLE_FIELD_ID_3,
} from "../../../configs/const";
import { SovBrandDatePicker } from "../../Shared/DatesField/SovBrandDatePicker";
import { AppContext } from "../../../context";
import { MultipleFlightTabletButton } from "./MultipleFlightTabletButton";

import sharedStyles from "../../Shared/styles.scss";
import multipleFlightStyles from "./multipleFlightTabletComponent.scss";

const MultipleFlightTabletComponent = ({
	index,
	selectedType,
	numberOfMultipleFlightInput,

	styles,
	classnames,
	defaultDate,
	previousDates,
	previousSession,

	isWidgetReset,
	isOnlyDateField,
	isValidSelectedTo,
	isValidSelectedFrom,
	isMultipleFlight,

	availableDates,
	multipleFlightData,
	isValidateMultipleCities,

	setMultipleFlightData,
	setValidateMultipleCities,
	setNumberOfMultipleFlightInput,
}) => {
	const [useAppState] = AppContext.useAppContext();
	const flightType =
		selectedType === "oneway" || selectedType === "OW" || selectedType === "multicity"
			? "date"
			: "range";
	
	const fromArrayId = [FLIGHTS_FROM_MULTIPLE_FIELD_ID_1, FLIGHTS_FROM_MULTIPLE_FIELD_ID_2, FLIGHTS_FROM_MULTIPLE_FIELD_ID_3];
	const toArrayId = [FLIGHTS_TO_MULTIPLE_FIELD_ID_1, FLIGHTS_TO_MULTIPLE_FIELD_ID_2, FLIGHTS_TO_MULTIPLE_FIELD_ID_3];
	let _levelIndex = 2

	if(index === 1) {
		_levelIndex = 3
	}
	if(index === 2) {
		_levelIndex = null
	}

	return (
		<div>
			<div className={multipleFlightStyles.multipleCitiesFlightHeader}>
				<span>{useAppState.getDictionary(`flight-${index + 1}`)}</span>
			</div>

			<div className={multipleFlightStyles.multipleFlightWrapper}>
				<FromField
					id={fromArrayId[index]}
					index={index}
					selectedType={selectedType}
					className={cx(sharedStyles.field, styles.fromField, styles.fromFieldTabletMultipleFields, {
						[styles.datesFieldMultipleFieldsError]: !isValidSelectedFrom
					})}
					error={!isValidateMultipleCities?.from}
					classnames={{
						brand: styles.brand,
						listViewButton: styles.listViewButton,
						inputIcon: styles.inputIcon,
						listViewIcon: styles.listViewIcon,
					}}
					selectedFrom={multipleFlightData?.[`flight${index + 1}`]?.selectedFrom}
					previousSessionValue={previousSession.selectedFrom}
					multipleFlightData={multipleFlightData}
					setMultipleFlightData={setMultipleFlightData}
				/>
				<ToField
					id={toArrayId[index]}
					index={index}
					className={cx(sharedStyles.field, styles.toField, styles.toFieldTabletMultipleFields, {
						[styles.datesFieldMultipleFieldsError]: !isValidSelectedTo
					})}
					error={!isValidateMultipleCities?.to}
					isSetMultipleFrom={{
						level: _levelIndex,
						isSetNextFrom: true,
					}}
					classnames={{
						brand: styles.brand,
						listViewButton: styles.listViewButton,
						inputIcon: styles.inputIcon,
						listViewIcon: styles.listViewIcon,
						listViewIconGoingTo: styles.listViewIconGoingTo,
					}}
					selectedType={selectedType}
					selectedFrom={multipleFlightData?.[`flight${index + 1}`]?.selectedFrom}
					selectedTo={multipleFlightData?.[`flight${index + 1}`]?.selectedTo}
					previousSessionValue={previousSession.selectedTo}
					multipleFlightData={multipleFlightData}
					setMultipleFlightData={setMultipleFlightData}
					setValidateMultipleCities={setValidateMultipleCities}
				/>
				<SovBrandDatePicker
					className={cx(sharedStyles.field, styles.datesField, styles.datesFieldMultipleFields)}
					id={FLIGHTS_DATES_FIELD_ID}
					type={flightType}
					helperText={!isValidateMultipleCities?.date && useAppState.getDictionary("invalid-date")}
					error={!isValidateMultipleCities?.date}
					isOnlyDateField={isOnlyDateField}
					isMultipleFlight={isMultipleFlight}
					classnames={classnames}
					defaultDate={defaultDate}
					availableDates={availableDates}
					previousDates={previousDates}
					isWidgetReset={isWidgetReset}
					onChange={startDate => {
						setMultipleFlightData(prev => ({
							...prev,
							[`flight${index + 1}`]: {
								...prev[`flight${index + 1}`],
								selectedDate: dayjs(startDate),
							},
						}));
					}}
				/>
				{numberOfMultipleFlightInput === index + 1 && (
					<MultipleFlightTabletButton
						index={index}
						numberOfMultipleFlightInput={numberOfMultipleFlightInput}
						styles={{
							multipleFlightButtonWrapper: multipleFlightStyles.multipleFlightButtonWrapper,
							multipleFlightButton: multipleFlightStyles.multipleFlightButton,
							plus: multipleFlightStyles.plus,
							minus: multipleFlightStyles.minus,
							plusDecrease: multipleFlightStyles.plusDecrease,
							plusIncrease: multipleFlightStyles.plusIncrease,
							plusDisabled: multipleFlightStyles.plusDisabled,
							hideIcon: multipleFlightStyles.hideIcon,
							noIpadHover: multipleFlightStyles.noIpadHover,
						}}
						setNumberOfMultipleFlightInput={setNumberOfMultipleFlightInput}
					/>
				)}
			</div>
		</div>
	);
};

MultipleFlightTabletComponent.propTypes = {
	selectedType: PropTypes.string,

	isWidgetReset: PropTypes.bool,
	isOnlyDateField: PropTypes.bool,
	isValidSelectedTo: PropTypes.bool,
	isValidSelectedFrom: PropTypes.bool,
	isMultipleFlight: PropTypes.bool,

	index: PropTypes.number,
	numberOfMultipleFlightInput: PropTypes.number,

	classnames: PropTypes.shape({
		listboxTail: PropTypes.string,
		listboxTailMultipleFLight: PropTypes.string,
	}),
	defaultDate: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.instanceOf(dayjs)),
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.instanceOf(dayjs),
		PropTypes.string,
	]),
	styles: PropTypes.shape({
		brand: PropTypes.string,
		toField: PropTypes.string,
		fromField: PropTypes.string,
		datesField: PropTypes.string,
		listViewButton: PropTypes.string,
		inputIcon: PropTypes.string,
		listViewIcon: PropTypes.string,
		listViewIconGoingTo: PropTypes.string,
		toFieldTabletMultipleFields: PropTypes.string,
		fromFieldTabletMultipleFields: PropTypes.string,
		datesFieldMultipleFields: PropTypes.string,
		datesFieldMultipleFieldsError: PropTypes.string,
	}),
	previousSession: PropTypes.shape({
		selectedFrom: PropTypes.string,
		selectedTo: PropTypes.string,
	}),
	availableDates: PropTypes.shape({
		RolloverAvailableDays: PropTypes.number,
		RolloverMaxAvailableDays: PropTypes.number,
		DefaultAvailableDate: PropTypes.string,
		DefaultMaxAvailableDate: PropTypes.string,
	}),
	isValidateMultipleCities: PropTypes.shape({
		from: PropTypes.bool,
		to: PropTypes.bool,
		date: PropTypes.bool,
	}),
	multipleFlightData: PropTypes.shape({
		flight1: PropTypes.shape({
			selectedFrom: PropTypes.shape({
				label: PropTypes.string,
				value: PropTypes.string,
			}),
			selectedTo: PropTypes.shape({
				label: PropTypes.string,
				value: PropTypes.string,
			}),
			selectedDates: PropTypes.oneOfType([
				PropTypes.arrayOf(PropTypes.instanceOf(dayjs)),
				PropTypes.arrayOf(PropTypes.string),
				PropTypes.instanceOf(dayjs),
				PropTypes.string,
			]),
		}),
		flight2: PropTypes.shape({
			selectedFrom: PropTypes.shape({
				label: PropTypes.string,
				value: PropTypes.string,
			}),
			selectedTo: PropTypes.shape({
				label: PropTypes.string,
				value: PropTypes.string,
			}),
			selectedDates: PropTypes.oneOfType([
				PropTypes.arrayOf(PropTypes.instanceOf(dayjs)),
				PropTypes.arrayOf(PropTypes.string),
				PropTypes.instanceOf(dayjs),
				PropTypes.string,
			]),
		}),
		flight3: PropTypes.shape({
			selectedFrom: PropTypes.shape({
				label: PropTypes.string,
				value: PropTypes.string,
			}),
			selectedTo: PropTypes.shape({
				label: PropTypes.string,
				value: PropTypes.string,
			}),
			selectedDates: PropTypes.oneOfType([
				PropTypes.arrayOf(PropTypes.instanceOf(dayjs)),
				PropTypes.arrayOf(PropTypes.string),
				PropTypes.instanceOf(dayjs),
				PropTypes.string,
			]),
		}),
	}),
	previousDates: PropTypes.arrayOf(PropTypes.string),

	setMultipleFlightData: PropTypes.func,
	setValidateMultipleCities: PropTypes.func,
	setNumberOfMultipleFlightInput: PropTypes.func,
};

MultipleFlightTabletComponent.defaultProps = {
	selectedType: "",

	isWidgetReset: false,
	isOnlyDateField: false,
	isValidSelectedTo: false,
	isValidSelectedFrom: false,
	isMultipleFlight: false,

	index: undefined,
	numberOfMultipleFlightInput: 1,

	classnames: undefined,
	defaultDate: undefined,
	styles: undefined,
	previousSession: undefined,
	availableDates: undefined,
	previousDates: undefined,
	multipleFlightData: undefined,
	isValidateMultipleCities: undefined,

	setMultipleFlightData: () => {},
	setValidateMultipleCities: () => {},
	setNumberOfMultipleFlightInput: () => {},
};

export default MultipleFlightTabletComponent;
export { MultipleFlightTabletComponent };
